import { configureStore } from '@reduxjs/toolkit';
import ordersSlice from './slices/ordersSlice';
import orderEditFormSlice from './slices/orderEditFormSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import systemNotificationSlice from './slices/systemNotificationSlice';
import transactionSlice from '@/reduxStore/slices/transactionsSlice';
import cardsSlice from '@/reduxStore/slices/cardsSlice';
import commonTermsSlice from '@/reduxStore/slices/comonTermsSlice';
import ibansSlice from '@/reduxStore/slices/ibansSlice';
import WebhookAndApiKeysSlice from '@/reduxStore/slices/webhookAndApiKeysSlice';
import usersSlice from './slices/usersSlice';
import exportSlice from './slices/exportSlice';
import clientsSlice from './slices/clientsSlice';
import linkPaymentSlice from '@/reduxStore/slices/linkPaymentSlice';
import rolesSlice from '@/reduxStore/slices/rolesSlice';

export const store = configureStore({
    reducer: {
        orders: ordersSlice,
        orderEditForm: orderEditFormSlice,
        systemNotification: systemNotificationSlice,
        transaction: transactionSlice,
        cards: cardsSlice,
        users: usersSlice,
        ibans: ibansSlice,
        commonTerms: commonTermsSlice,
        webhookAndApiKeys: WebhookAndApiKeysSlice,
        export: exportSlice,
        linkPayment: linkPaymentSlice,
        roles: rolesSlice,
        clients: clientsSlice,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
